<p-drawer
  [(visible)]="visible"
  position="right"
  [modal]="true"
  [closable]="false"
  [dismissible]="true"
  [style]="{ width: 'min(95vw, 860px)' }"
  styleClass="permissoes-drawer efetivo-drawer-dark"
  (onHide)="onHide()"
>
  <ng-template pTemplate="header">
    <div class="drawer-header">
      <div class="header-title">
        <i class="ri-shield-keyhole-line header-icon"></i>
        <div>
          <h2>Permissões — {{ grupo?.nome }}</h2>
          <p class="header-subtitle" *ngIf="!carregando && !erro">
            {{ pendenteCount }} de {{ totalOpcoes }} permissões atribuídas
            <span class="pendente-flag" *ngIf="temAlteracoesPendentes"> · alterações por guardar</span>
          </p>
        </div>
      </div>
      <button type="button" class="close-btn" (click)="fechar()" aria-label="Fechar">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </ng-template>

  <div class="drawer-body">
    <div class="matriz-skeleton" *ngIf="carregando">
      <p-skeleton height="70px" borderRadius="10px"></p-skeleton>
      <p-skeleton height="46px" borderRadius="9px"></p-skeleton>
      @for (i of [1, 2, 3, 4, 5]; track i) { <p-skeleton height="48px" styleClass="mb-2"></p-skeleton> }
    </div>

    <div class="error-state" *ngIf="!carregando && erro">
      <i class="ri-error-warning-line"></i>
      <strong>Não foi possível carregar as permissões</strong>
      <p>Verifique a ligação e tente novamente.</p>
      <button class="btn-web-secondary" type="button" (click)="retry()"><i class="ri-refresh-line"></i> Tentar novamente</button>
    </div>

    <ng-container *ngIf="!carregando && !erro">
      <div class="permission-summary">
        <span><i class="ri-checkbox-circle-line"></i><small>Atribuídas</small><strong>{{ pendenteCount }}</strong></span>
        <span><i class="ri-shield-keyhole-line"></i><small>Disponíveis</small><strong>{{ totalOpcoes }}</strong></span>
        <span [class.has-changes]="temAlteracoesPendentes"><i class="ri-edit-circle-line"></i><small>Alterações</small><strong>{{ temAlteracoesPendentes ? 'Por guardar' : 'Nenhuma' }}</strong></span>
      </div>

      <section class="permission-list-toolbar" aria-label="Pesquisa e filtros das permissões">
        <button type="button" class="open-permission-filters" (click)="showPermissionFiltersDrawer = true">
          <i class="ri-filter-3-line"></i>
          <span>Filtros</span>
          <b *ngIf="permissionFiltersCount">{{ permissionFiltersCount }}</b>
        </button>
        <div class="permission-search">
          <i class="ri-search-line"></i>
          <input type="search" [value]="permissionSearch" placeholder="Pesquisar módulo ou permissão..."
            (input)="onPermissionSearch($any($event.target).value)" />
          <button *ngIf="permissionSearch" type="button" aria-label="Limpar pesquisa" (click)="clearPermissionSearch()">
            <i class="ri-close-line"></i>
          </button>
        </div>
      </section>

      <div class="matriz-toolbar">
        <div class="permission-results-copy">
          <strong>{{ totalLinhasFiltradas }}</strong>
          <span>{{ totalLinhasFiltradas === 1 ? 'módulo encontrado' : 'módulos encontrados' }}</span>
          <small>A seleção é mantida ao mudar de página.</small>
        </div>
        <label class="toggle-todas">
          <p-checkbox [binary]="true" [ngModel]="estadoGlobalChecked" [indeterminate]="estadoGlobalIndeterminate"
            (onChange)="toggleTodas()" [ariaLabel]="estadoGlobalLabel"></p-checkbox>
          <span>{{ estadoGlobalLabel }}</span>
        </label>
      </div>

      <div class="matriz-wrapper" *ngIf="totalLinhasFiltradas > 0">
        <div class="matriz-grid">
          <div class="grid-row grid-header">
            <div class="cell-control"></div>
            <div class="cell-modulo">Módulo</div>
            <div class="cell-acao">Visualizar</div>
            <div class="cell-acao">Criar</div>
            <div class="cell-acao">Editar</div>
            <div class="cell-acao">Eliminar</div>
            <div class="cell-outras">Outras</div>
          </div>

          @for (linha of linhasPaginadas; track trackByModulo($index, linha)) {
            <div class="grid-row">
              <div class="cell-control">
                <p-checkbox [binary]="true" [ngModel]="linha.checked" [indeterminate]="linha.indeterminate"
                  (onChange)="toggleLinha(linha)" [ariaLabel]="'Marcar todas as permissões de ' + linha.modulo"></p-checkbox>
              </div>
              <div class="cell-modulo"><span>{{ linha.modulo }}</span><small>{{ linha.roles.length }} permissões</small></div>
              <div class="cell-acao"><p-checkbox *ngIf="linha.celulas.VISUALIZAR as c" [binary]="true" [ngModel]="c.checked" [ariaLabel]="c.ariaLabel" (onChange)="toggle(c.roleEnum)"></p-checkbox></div>
              <div class="cell-acao"><p-checkbox *ngIf="linha.celulas.CRIAR as c" [binary]="true" [ngModel]="c.checked" [ariaLabel]="c.ariaLabel" (onChange)="toggle(c.roleEnum)"></p-checkbox></div>
              <div class="cell-acao"><p-checkbox *ngIf="linha.celulas.EDITAR as c" [binary]="true" [ngModel]="c.checked" [ariaLabel]="c.ariaLabel" (onChange)="toggle(c.roleEnum)"></p-checkbox></div>
              <div class="cell-acao"><p-checkbox *ngIf="linha.celulas.ELIMINAR as c" [binary]="true" [ngModel]="c.checked" [ariaLabel]="c.ariaLabel" (onChange)="toggle(c.roleEnum)"></p-checkbox></div>
              <div class="cell-outras">
                @for (opt of linha.outras; track trackByValor($index, opt)) {
                  <label class="outra-opcao"><p-checkbox [binary]="true" [ngModel]="opt.checked" [ariaLabel]="opt.ariaLabel" (onChange)="toggle(opt.roleEnum)"></p-checkbox><span>{{ opt.label }}</span></label>
                }
                <span *ngIf="!linha.outras.length" class="not-applicable">—</span>
              </div>
            </div>
          }
        </div>
      </div>

      <div *ngIf="totalLinhasFiltradas === 0" class="permissions-empty-filter">
        <span><i class="ri-shield-search-line"></i></span>
        <strong>Nenhuma permissão encontrada</strong>
        <p>Ajuste a pesquisa ou remova os filtros aplicados.</p>
        <button type="button" (click)="clearPermissionFilters()"><i class="ri-filter-off-line"></i> Limpar filtros</button>
      </div>

      <div class="permission-pagination" *ngIf="totalLinhasFiltradas > 0">
        <app-paginator-control [first]="permissionFirst" [rows]="permissionPageSize"
          [totalRecords]="totalLinhasFiltradas" [rowsPerPageOptions]="[5, 10, 20]"
          [alwaysShow]="true" [showCurrentPageReport]="true" (pageChange)="onPermissionPageChange($event)">
        </app-paginator-control>
      </div>
    </ng-container>
  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="btn-web-secondary" (click)="fechar()">
      Cancelar
    </button>
    <button
      type="button"
      class="btn-web-primary"
      [disabled]="!temAlteracoesPendentes || salvando"
      (click)="salvarAlteracoes()"
    >
      <i [class]="salvando ? 'fas fa-spinner fa-spin' : 'fas fa-save'"></i>
      Guardar alterações
    </button>
  </ng-template>
</p-drawer>


<p-drawer
  [(visible)]="showPermissionFiltersDrawer"
  position="right"
  [modal]="true"
  appendTo="body"
  [closable]="false"
  [style]="{ width: 'min(92vw, 390px)' }"
  styleClass="permission-filters-drawer"
>
  <ng-template pTemplate="header">
    <div class="permission-filter-drawer-title">
      <span><i class="ri-filter-3-line"></i></span>
      <div><h2>Filtrar permissões</h2><p>Escolha a ação e o estado de atribuição.</p></div>
      <button type="button" aria-label="Fechar filtros" (click)="showPermissionFiltersDrawer = false">
        <i class="ri-close-line"></i>
      </button>
    </div>
  </ng-template>

  <div class="permission-filter-drawer-body">
    <label>
      <span>Acção</span>
      <select [value]="permissionActionFilter" (change)="onPermissionActionFilter($any($event.target).value)">
        <option value="TODAS">Todas as acções</option>
        <option value="VISUALIZAR">Visualizar</option>
        <option value="CRIAR">Criar</option>
        <option value="EDITAR">Editar</option>
        <option value="ELIMINAR">Eliminar</option>
        <option value="OUTRAS">Outras acções</option>
      </select>
    </label>
    <label>
      <span>Atribuição</span>
      <select [value]="permissionAssignmentFilter" (change)="onPermissionAssignmentFilter($any($event.target).value)">
        <option value="TODAS">Todos os estados</option>
        <option value="ATRIBUIDAS">Com acesso</option>
        <option value="NAO_ATRIBUIDAS">Sem acesso</option>
        <option value="COMPLETAS">Módulo completo</option>
      </select>
    </label>
    <div class="permission-filter-note">
      <i class="ri-information-line"></i>
      <span>A pesquisa por módulo continua disponível à direita da barra da listagem.</span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="btn-web-secondary" (click)="clearAdvancedPermissionFilters()">Limpar</button>
    <button type="button" class="btn-web-primary" (click)="showPermissionFiltersDrawer = false">
      <i class="ri-check-line"></i> Ver resultados
    </button>
  </ng-template>
</p-drawer>
